import { useMemo } from "react";
import { useLearningCatalogue } from "../context";

export const useFilter = () => {
  const { state, setCategoriesValue, updateFilters, resetFilters } =
    useLearningCatalogue();

  const {
    otherCategories,
    categoriesValue,
    startDate,
    endDate,
    sessionRegion,
    sessionCity,
    learningActivities,
    hasActiveFilters,
    allUniqueRegions: stateUniqueRegions,
    allUniqueCities: stateUniqueCities,
  } = state;

  const toArray = (val) => {
    if (Array.isArray(val)) {
      return val;
    }
    if (!val) {
      return [];
    }
    return [val];
  };

  const handleChange = (event, categoryName, value) => {
    const updatedCategoriesValue = {
      ...categoriesValue,
      [categoryName]: toArray(value),
    };
    setCategoriesValue(updatedCategoriesValue);
  };

  const handleDateChange = (event, name, value) => {
    updateFilters({ [name]: value });
  };

  const handleSessionChange = (event, name, value) => {
    updateFilters({ [name]: toArray(value) });
  };

  // Use full-catalogue region/city lists so Område and Ort filters stay visible when category filters are applied
  const { uniqueRegions, uniqueCities } = useMemo(() => {
    if (Array.isArray(stateUniqueRegions) && Array.isArray(stateUniqueCities)) {
      return {
        uniqueRegions: stateUniqueRegions,
        uniqueCities: stateUniqueCities,
      };
    }
    const coursesToCheck =
      learningActivities?.allFilteredCourses ||
      learningActivities?.courses ||
      [];
    if (!coursesToCheck.length) {
      return { uniqueRegions: [], uniqueCities: [] };
    }
    const regions = new Set();
    const cities = new Set();
    coursesToCheck.forEach((course) => {
      if (course.sessions && Array.isArray(course.sessions)) {
        course.sessions.forEach((session) => {
          if (session.region) regions.add(session.region);
          if (session.city) cities.add(session.city);
        });
      }
    });
    return {
      uniqueRegions: Array.from(regions).sort(),
      uniqueCities: Array.from(cities).sort(),
    };
  }, [
    stateUniqueRegions,
    stateUniqueCities,
    learningActivities?.allFilteredCourses,
    learningActivities?.courses,
  ]);

  const hitCount = learningActivities?.totalAmountOfCourses || 0;

  return {
    otherCategories,
    categoriesValue,
    startDate,
    endDate,
    sessionRegion,
    sessionCity,
    hasActiveFilters,
    hitCount,
    uniqueRegions,
    uniqueCities,
    handleChange,
    handleDateChange,
    handleSessionChange,
    resetFilters,
  };
};
